module.exports = require('imports-loader?this=>window!exports-loader?Blockly&goog!../blockly_compressed_vertical');
